module.exports = "https://static.wmbcdn.com/uniweb/images/13142aabf3fd637e6e4de7a275dabb42.webp";